import { InfoTooltip } from "components/Table/components";
import { renderAvailableData } from "components/TableDetails/functions";

import SingleInfo from "./SingleInfo";
import { TitleInfoProps } from "./types";

const TitleInfo = ({ cardName, list, ...props }: TitleInfoProps) => {
    return (
        <InfoTooltip
            {...props}
            title={
                <ul>
                    {renderAvailableData(list).map(({ title }) => {
                        return (
                            <SingleInfo
                                key={title}
                                cardName={cardName}
                                title={title}
                            />
                        );
                    })}
                </ul>
            }
        />
    );
};

export { TitleInfo };
